import * as React from "react";

import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import { Modal } from "../../components/modal/Modal";
import {
  getCountries,
  deleteCountry,
} from "../../redux/actions/countryActions";
import { useAppDispatch } from "../../redux/hooks";
import { CountryResponse } from "../../api/generated/index";
import { SUCCESS_DELETE } from "../../constants/messageConstants";
import { handleErrors, handleToast } from "../../utils/helpers";

interface CountryTableProps {
  countries: CountryResponse[];
}

export const CountryTable: React.FC<CountryTableProps> = ({ countries }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentItem = React.useRef<CountryResponse | null>(null);
  const [showDeletePopup, setShowDeletePopup] = React.useState<boolean>(false);

  const handleOpen = (item: CountryResponse) => {
    setShowDeletePopup(true);
    currentItem.current = item;
  };
  const handleClose = () => {
    setShowDeletePopup(false);
  };

  const onDelete = (id: number) => {
    dispatch(deleteCountry(id))
      .unwrap()
      .then(() => {
        dispatch(getCountries());
        handleToast(SUCCESS_DELETE);
      })
      .catch((res) => {
        handleErrors(res);
      });
    handleClose();
  };

  const onCancel = () => {
    handleClose();
  };

  const onAdd = (id: number) => {
    navigate(`new/${id}`);
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <h2 className="manager__title">List of added countries</h2>
      <div className="manager__content">
        <table className="table">
          <thead>
            <tr className="table__row">
              <th className="table__head">Country name</th>
              <th className="table__head table__head--action">Edit</th>
              <th className="table__head table__head--action">Delete</th>
            </tr>
          </thead>
          <tbody>
            {countries.map((item) => {
              return (
                <tr className="table__row" key={item.id}>
                  <td className="table__cell">{item.name}</td>
                  <td className="table__cell">
                    <button
                      onClick={() => onAdd(item.id!)}
                      className="link link--icon link--edit"
                    >
                      Edit
                    </button>
                  </td>
                  <td className="table__cell">
                    <button
                      onClick={() => handleOpen(item)}
                      className="link link--icon link--delete"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Modal show={showDeletePopup} handleClose={onCancel}>
        <h2 className="popup__heading-plain">
          Are you sure you want to delete this country?
        </h2>
        <div className="popup__actions">
          <button
            onClick={onCancel}
            type="button"
            className="btn btn--transparent popup__btn"
          >
            Cancel
          </button>
          <button
            onClick={() => onDelete(currentItem.current?.id!)}
            type="button"
            className="btn popup__btn"
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
